import { Polyline } from "react-leaflet";

export default function EmergencyRouteLayer({ coordinates, color }) {
  return (
    <>
      {coordinates.map((group, index) => (
        <Polyline
          key={`${color}-${index}`}
          positions={group}
          color={color}
          weight={3}
        >
          {/* <Tooltip direction="top" offset={[0, -10]} opacity={1}>
            {label}
          </Tooltip> */}
        </Polyline>
      ))}
    </>
  );
}